import { fetchWithCache, getCachedData } from "../services/apiService";

export const propertyStats = async ({ setPropStats }) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/property/propertyStats", {});
  if (cached) {
    setPropStats(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/property/propertyStats",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );

    if (data) {
      setPropStats(data);
    } else if (!cached) {
      setPropStats(null);
    }
  } catch (error) {
    if (!cached) {
      setPropStats(null);
    }
  }
};
